/* Gift wrapping — cart module + PDP explainer.
 *
 * Stateless by design: the checkbox/note markup is re-rendered server-side
 * (snippets/gy-gift-wrap.liquid) on every cart change, and Dawn's cart.js
 * swaps the drawer/cart sections wholesale. So all listeners are delegated
 * at document level and every mutation ends in a section repaint — the DOM
 * is always derived from the cart, never from JS memory.
 */
(function () {
  'use strict';
  if (window.__gyGiftWrap) return;
  window.__gyGiftWrap = true;

  var BUSY = false;
  var NOTE_STASH_KEY = 'gy-gw-note'; // survives an untick within the session

  function track(name, params) {
    if (typeof window.gyTrack === 'function') window.gyTrack(name, params);
  }

  function root(el) {
    return el ? el.closest('gy-gift-wrap') : null;
  }
  function modules() {
    return document.querySelectorAll('gy-gift-wrap');
  }
  function setBusy(on) {
    BUSY = on;
    modules().forEach(function (m) { m.classList.toggle('is-busy', on); });
  }

  /* ── section repaint (mirrors the theme's own swap targets) ── */
  function sectionPlan() {
    var plan = [];
    if (document.getElementById('CartDrawer')) {
      plan.push({ section: 'cart-drawer', target: '#CartDrawer', pick: '#CartDrawer' });
    }
    if (document.getElementById('cart-icon-bubble')) {
      plan.push({ section: 'cart-icon-bubble', target: '#cart-icon-bubble', pick: '.shopify-section' });
    }
    var mci = document.getElementById('main-cart-items');
    if (mci && mci.dataset.id) {
      plan.push({ section: mci.dataset.id, target: '#main-cart-items .js-contents', pick: '.js-contents' });
    }
    var mcf = document.getElementById('main-cart-footer');
    if (mcf && mcf.dataset.id && mcf.dataset.id !== (mci && mci.dataset.id)) {
      plan.push({ section: mcf.dataset.id, target: '#main-cart-footer .js-contents', pick: '.js-contents' });
    }
    return plan;
  }

  function paint(sections, plan) {
    plan.forEach(function (p) {
      var html = sections && sections[p.section];
      var target = document.querySelector(p.target);
      if (!html || !target) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source = doc.querySelector(p.pick);
      if (source) target.innerHTML = source.innerHTML;
    });
  }

  function cartPost(path, body) {
    return fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  /* Final call of every flow: update attributes (+ any qty change) and
     repaint all cart surfaces from the same response. */
  function updateAndPaint(body) {
    var plan = sectionPlan();
    body.sections = plan.map(function (p) { return p.section; });
    body.sections_url = window.location.pathname;
    return cartPost('/cart/update.js', body).then(function (cart) {
      paint(cart.sections, plan);
      return cart;
    });
  }

  function toggleOn(variantId) {
    setBusy(true);
    var stashed = '';
    try { stashed = sessionStorage.getItem(NOTE_STASH_KEY) || ''; } catch (e) {}
    // Paint straight from the add response (checked state comes from the line
    // item, not the attribute), then set attributes behind the paint — halves
    // the perceived wait. A stashed note needs the second paint to show up.
    var plan = sectionPlan();
    cartPost('/cart/add.js', {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: plan.map(function (p) { return p.section; }),
      sections_url: window.location.pathname,
    })
      .then(function (added) {
        paint(added.sections, plan);
        setBusy(false);
        track('gift_wrap_toggle', { state: 'on' });
        var ta = document.querySelector('gy-gift-wrap.on [data-gy-gw-note]');
        if (ta) ta.focus({ preventScroll: true });
        var body = { attributes: { 'Gift wrap': 'Yes', 'Gift note': stashed } };
        if (stashed) return updateAndPaint(body);
        return cartPost('/cart/update.js', body);
      })
      .catch(function () {})
      .finally(function () { setBusy(false); });
  }

  function toggleOff(variantId, opts) {
    opts = opts || {};
    setBusy(true);
    if (!opts.silent) {
      var ta = document.querySelector('gy-gift-wrap [data-gy-gw-note]');
      try { sessionStorage.setItem(NOTE_STASH_KEY, (ta && ta.value) || ''); } catch (e) {}
    }
    var updates = {};
    updates[variantId] = 0;
    updateAndPaint({ updates: updates, attributes: { 'Gift wrap': '', 'Gift note': '' } })
      .then(function (cart) {
        if (!opts.silent) track('gift_wrap_toggle', { state: 'off', cart_total: cart.total_price });
      })
      .finally(function () { setBusy(false); });
  }

  function saveNote(ta) {
    var value = ta.value.trim().slice(0, 180);
    var btn = root(ta) && root(ta).querySelector('[data-gy-gw-save]');
    if (btn) btn.textContent = 'Saving…';
    setBusy(true);
    try { sessionStorage.setItem(NOTE_STASH_KEY, value); } catch (e) {}
    updateAndPaint({ attributes: { 'Gift wrap': 'Yes', 'Gift note': value } })
      .then(function () { track('gift_note_save', { length: value.length }); })
      .finally(function () { setBusy(false); });
  }

  /* ── self-cleaning: runs after every DOM swap, whoever caused it ──
     - orphan: the wrap is the only line left → remove it + clear attributes
       (Liquid already renders a wrap-only cart as empty, this makes it real)
     - qty drift: anything ever bumps the wrap above 1 → normalize back */
  function sweep() {
    if (BUSY) return;
    var m = document.querySelector('gy-gift-wrap[data-orphan]');
    if (m) {
      try { sessionStorage.removeItem(NOTE_STASH_KEY); } catch (e) {}
      toggleOff(m.dataset.variantId, { silent: true });
      return;
    }
    var over = document.querySelector('gy-gift-wrap');
    if (over && Number(over.dataset.qty) > 1) {
      setBusy(true);
      var updates = {};
      updates[over.dataset.variantId] = 1;
      updateAndPaint({ updates: updates }).finally(function () { setBusy(false); });
    }
  }

  var sweepTimer = null;
  function scheduleSweep() {
    clearTimeout(sweepTimer);
    sweepTimer = setTimeout(sweep, 200);
  }

  function observe() {
    var seen = [];
    [document.querySelector('cart-drawer'),
     document.getElementById('main-cart-items'),
     document.getElementById('main-cart-footer')].forEach(function (host) {
      if (!host) return;
      seen.push(host);
      new MutationObserver(scheduleSweep).observe(host, { childList: true, subtree: true });
    });
    if (!seen.length) {
      new MutationObserver(scheduleSweep).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ── delegated events ── */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-gy-gw-toggle]');
    if (toggle && !BUSY) {
      var m = root(toggle);
      if (m.classList.contains('on')) toggleOff(m.dataset.variantId);
      else toggleOn(m.dataset.variantId);
      return;
    }
    var save = e.target.closest('[data-gy-gw-save]');
    if (save && !BUSY) {
      var ta = root(save).querySelector('[data-gy-gw-note]');
      if (ta) saveNote(ta);
      return;
    }
    var info = e.target.closest('[data-gy-gw-info]');
    if (info) {
      // Both PDP breakpoint sections can exist in the same DOM — resolve the
      // panel inside this trigger's own scope, never the first on the page.
      var scope = info.closest('[data-gy-gw-info-scope]') || document;
      var panel = scope.querySelector('[data-gy-gw-info-panel]');
      if (panel) {
        var open = panel.classList.toggle('on');
        if (open) track('gift_wrap_info_open', { page: 'pdp' });
      }
      e.stopPropagation();
      return;
    }
    // click-away closes the PDP explainer (desktop popover behavior)
    var stray = document.querySelector('[data-gy-gw-info-panel].on');
    if (stray && !e.target.closest('[data-gy-gw-info-panel]')) stray.classList.remove('on');
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-gy-gw-note]')) return;
    var m = root(e.target);
    var count = m.querySelector('[data-gy-gw-count]');
    if (count) count.textContent = String(e.target.value.length);
    var save = m.querySelector('[data-gy-gw-save]');
    if (save) {
      save.disabled = false;
      save.classList.remove('saved');
      save.textContent = 'Save note';
    }
  });

  // Autosave on blur — safety net behind the explicit button. Only fires
  // when the text actually differs from what the server already holds.
  document.addEventListener('focusout', function (e) {
    if (!e.target.matches('[data-gy-gw-note]')) return;
    if (BUSY) return;
    if (e.target.value.trim() === (e.target.dataset.savedValue || '').trim()) return;
    saveNote(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(); scheduleSweep(); });
  } else {
    observe();
    scheduleSweep();
  }
})();
